module.exports = __webpack_public_path__ + "media/svg/mg-929451ed.svg";